// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2Y9Vm","left":"StickyBox_left__13-Gp","right":"StickyBox_right__2srLG"};